const alertElement = document.querySelector('.alert')
if (alertElement) {
    const buttonClose = alertElement.querySelector('.btn-close')
    const alertActiveElements = document.querySelectorAll('.alert-active')

    buttonClose.addEventListener('click', () => {
        alertActiveElements.forEach(element => {
            element.classList.remove('alert-active')
        })
    })
}